import { Component } from 'react';
import {Col} from 'react-bootstrap';
import BsCheckbox from '../common/form/elements/bs-checkbox';

class MessageHeader extends Component {
  onMessageChecked = (event, id) => this.props.onMessageChecked(id, event.target.checked);

  render() {
    const {checked, message, checkbox} = this.props;

    return (
      <Col className="panel-body-checkbox" sm={1}>
        {checkbox && (
        <BsCheckbox
          inline
          checked={checked}
          onChange={e => this.onMessageChecked(e, message.id)}
          className="check-message"
        />
)}
      </Col>
    );
  }
}

export default MessageHeader;
